import {action, computed, makeObservable, observable} from 'mobx';
import {ReportGeneratorStore} from '../../ReportGenerator/stores/ReportGeneratorStore';
import {IReport} from '../../ReportGenerator/types';
import {SupportedValue} from '@priority-software/priority-style-react/dist/components/DropdownV2/ChooseDropdown/ChooseDropdown';
import texts from '../../ReportGenerator/texts';
import {COL_IDS} from '../../ReportGenerator/componenets/ReportList/consts';
import {priority} from '@priority-software/priority-proto-api/lib';

export class AnalyticsReportsStore extends ReportGeneratorStore {
    constructor(props: any) {
        super(props);
        makeObservable(this);
    }
    @observable selectedReport: IReport = null;
    @observable selectedUsers: SupportedValue[] | [] = [];
    @observable selectedForms: SupportedValue[] | [] = [];

    @action
    setSelectedReport = (id: number) => {
        this.selectedReport = this.reports.find(rep => (rep.id as number) === id);
    };

    @action
    resetFilters = () => {
        this.selectedUsers = [];
        this.selectedForms = [];
        this.listSearchQuery = undefined;
        this.currentNavPage = 1;
    };

    @action
    setSelectedUsers = (names: SupportedValue[] | []) => {
        this.selectedUsers = names;
        this.currentNavPage = 1;
    };

    @action
    setSelectedForms = (forms: SupportedValue[] | []) => {
        this.selectedForms = forms;
        this.currentNavPage = 1;
    };

    @action
    onClose = () => {
        this.selectedReport = null;
        this.reports = undefined;
        this.forms = undefined;
        this.listSearchQuery = undefined;
        this.selectedUsers = [];
        this.selectedForms = [];
        this.setSort({id: COL_IDS.title, isDesc: false, isDefault: true});

        this.close();
    };

    @computed
    get reportsByType(): IReport[] {
        return (
            this.reports?.filter(
                report =>
                    (report.reportType === priority.netitems.nrest.RepType.RepType_Report ||
                        report.reportType === priority.netitems.nrest.RepType.RepType_OldReport) &&
                    report.isActive
            ) || []
        );
    }

    @computed
    get users(): Array<{label: string; value: string}> {
        return [...new Set(this.reports?.map(report => report.userName))].map(item => ({
            value: item || '',
            label: item || ''
        }));
    }
    @computed
    get basedForms(): Array<{label: string; value: string}> {
        return [...new Set(this.reports?.map(report => report.baseForm))]
            .map(item => ({
                value: item || '',
                label: item || texts.OldGenerator
            }))
            .sort((a, b) => a.label.localeCompare(b.label));
    }
}

export const analyticsReportsStore = new AnalyticsReportsStore('analytics-reports-dialog');
